import React from 'react';

const AllowedExtraTimeGrayIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-3207 -1630) translate(2558 1569) translate(632 63) translate(19.5)">
              <circle cx="9.5" cy="9.5" r="10.5" fill="#999" stroke="#999" strokeWidth="2" />
              <g stroke="#FFF">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.55 3.8L9.55 9.495 12.75 11.8" />
                <g>
                  <g>
                    <circle cx="9.5" cy="9.5" r="9.5" />
                  </g>
                  <path fill="#999" fillRule="nonzero" d="M19.3-.5h-2.6v3.2h-3.2v2.6h3.2v3.2h2.6V5.3h3.2V2.7h-3.2V-.5z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

);

export default AllowedExtraTimeGrayIcon;
